//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/TransientObject.js";
let d=[[[0,"AttributeCustomizedFormulas",1,0],[0,"ClassName",1,0]],[[[],"Dispose",{},0,0],[["numberOfChildCheckers"],"GetChildCheckerInstanceNames",{R_:{childCheckerInstances:""}},0,0],[["numberOfChildCheckers","childCheckerInstances"],"GetChildCheckerEnabledFlags",{R_:{enableFlags:""}},0,0],[["childCheckerInstances","enableFlags"],"SetChildCheckerEnabledFlags",{},2,0],[["childCheckerInstance"],"GetChildCheckerEnabledFlag",{R_:{enableFlag:''}},1,0],[["childCheckerInstance","enableFlag"],"SetChildCheckerEnabledFlag",{},2,0],[["parameterTitle"],"GetParameter",{R_:{parameter:"Validate.Parameter"}},1,0],[["numParameters"],"GetParameters",{R_:{parameters:"Validate.Parameter[]"}},0,0],[[],"AskLogger",{R_:{logger:"Validate.Logger"}},0,0]],[]];
SPLM.Validate.CheckerNode = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.CheckerNode";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;